import PoiSub from "@/components/PoiSub/PoiSub";
import moment from "moment";
export default {
  extends: PoiSub,
  methods: {
    moment
  }
};
